<template>
  <div class="log-label">
    <div
      v-if="icon"
      class="log-label__icon"
      :class="`log-label__icon_${icon}`"
    >
      <font-awesome-icon :icon="icon" />
    </div>
    <div
      class="log-label__label"
      :class="{'log-label__label_bordered': bordered}"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LabelWithIcon',
    props: {
      icon: {
        type: [Object, Array, String],
        default: '',
      },
      bordered: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style lang="less" scoped>
.log-label {
  margin-right: 1.5em;
  display: flex;
  align-items: center;
  margin-bottom: 1em;

  &:last-child {
    margin-right: 0;
    margin-bottom: 0;
  }

  &__icon {

    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;

    color: #ff9100;
    margin-right: 0.7em;
    font-size: 1.5em;
    width: auto;
    height: auto;

    &_plus {
      width: 1.7em;
      height: 1.7em;
      font-size: 1em;
      background: #4caf50;
      color: white;
    }

    &_minus {
      width: 1.7em;
      height: 1.7em;
      font-size: 1em;
      background: #FF0034;
      color: white;
    }

    &_clock {
      //background: #ff9100;
      //color: white;
      font-size: 1.5em;
      width: auto;
      height: auto;
    }
  }

  &__label {
    &_bordered {
      padding: 0.1em 0.3em;
      border: 1px dashed;
      border-radius: 4px;
    }
  }

}
</style>
